import phoneInstance from './instance'

const storePhone = (data) => {
	return phoneInstance.post('/voip-settings', data)
}

export default storePhone
